import { captureException, captureMessage } from '@sentry/react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../utils/auth';

const ALLOWED_EXTERNAL_ORIGINS = [
  'https://api.gusto.com',
  'https://api.gusto-demo.com',
];

export function useSafeLocationUpdate() {
  const navigate = useNavigate();
  return useCallback(
    (path: string, replace = false) => {
      try {
        const url = new URL(path);
        const isInternal = url.origin === window.location.origin;

        if (!isInternal && !ALLOWED_EXTERNAL_ORIGINS.includes(url.origin)) {
          throw new Error(`Forbidden redirect URL: ${url.href}`);
        }

        captureMessage(`Safely redirecting user to: ${url.origin}`, 'debug');

        if (isInternal) {
          navigate(url.pathname + url.search + url.hash, { replace });
        } else {
          logout().then(() => {
            if (replace) {
              window.location.replace(url);
            } else {
              window.location.href = url.toString();
            }
          });
        }
      } catch (err) {
        captureException(err);
        return;
      }
    },
    [navigate],
  );
}
